import { Box, Chip, Grid } from '@material-ui/core';
import React, { useRef, useState } from 'react';
import moment from 'moment-timezone';

import { ISegmentCuration } from '../../services/types';
import useStyles from './styles';
import titleize from 'titleize';
import { getStatusByDates } from '../../services/utils';

interface LabelProps {
  startsAt: Date | null;
  endsAt: Date | null;
  margin?: number;
}

export const ActiveStatusLabel = (props: LabelProps): JSX.Element => {
  const classes = useStyles();
  const start = props.startsAt;
  const end = props.endsAt;

  let statusText = '';
  let statusColor = '';
  const style: React.CSSProperties = {};
  if (props.margin) {
    style.marginRight = props.margin;
  }
  const status = getStatusByDates(start, end);
  if (status === 'scheduled') {
    statusText = 'Scheduled';
    statusColor = classes.colorScheduled;
  } else if (status === 'completed') {
    statusText = 'Completed';
    statusColor = classes.colorCompleted;
  } else {
    statusText = 'Activated';
    statusColor = classes.colorActive;
  }

  return (
    <span className={`${classes.statusLabel} ${statusColor}`} style={style}>
      {statusText}
    </span>
  );
};

interface TypeProps {
  type: string;
}
export const TargetTypeLabel = (props: TypeProps): JSX.Element => {
  const classes = useStyles();
  let color = '';
  if (props.type.toLowerCase() === 'story') {
    color = classes.colorStory;
  } else if (props.type.toLowerCase() === 'season') {
    color = classes.colorSeason;
  } else if (props.type.toLowerCase() === 'collection') {
    color = classes.colorCollection;
  } else if (props.type.toLowerCase() === 'link') {
    color = classes.colorLink;
  } else if (props.type.toLowerCase() === 'a/b') {
    color = classes.colorAbtest;
  } else {
    color = 'default';
  }
  return <label className={`${classes.typeLabel} ${color}`}>{props.type}</label>;
};
